import { Col } from 'antd'

import { HivFormItem } from '../HivFormItem'
import { TriStateRadio } from '../TriStateRadio'

type Props = {
  name: (string | number)[]
  number: string
  label: string
  /** Since 2026-10-15 the questions are optional (only 43 is required). */
  isRequired?: boolean
  span?: number
  /** Only Da / Nu (54, 55, 57–59). */
  yesNoOnly?: boolean
}

/** A Da / Nu / ? question of the form in its own column. */
export const TriStateItem = ({
  name,
  number,
  label,
  isRequired = false,
  span = 12,
  yesNoOnly = false
}: Props) => (
  <Col xs={24} lg={span}>
    <HivFormItem
      name={name}
      number={number}
      label={label}
      rules={[{ required: isRequired }]}
    >
      <TriStateRadio yesNoOnly={yesNoOnly} />
    </HivFormItem>
  </Col>
)
